import React from "react";
import { motion } from "framer-motion";

const HiringUpskilling = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 },
        },
    };

    const fadeUpVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-white py-12 sm:py-16 md:py-20 lg:py-24 text-left relative z-10 overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full flex flex-col gap-16 sm:gap-20 md:gap-24 px-5 sm:px-10 lg:px-[80px] ">

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    className="flex flex-col lg:flex-row gap-6 justify-between lg:gap-16 items-start w-full"
                >
                    <motion.div variants={fadeUpVariants} className="lg:max-w-[408px] w-full flex flex-col justify-between h-auto min-h-full">
                        <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] font-sora leading-[1.4] tracking-tight break-words w-full mb-4 lg:mb-0">
                            We believe in skill-based <br /> and bias-free hiring
                        </h2>
                    </motion.div>
                    <motion.div variants={fadeUpVariants} className="lg:max-w-[666px] w-full flex flex-col justify-end h-auto min-h-full">
                        <p className="text-[14px] md:text-[16px] text-[#49577A] font-graphik font-[500] leading-relaxed break-words w-full">
                            As part of our inclusive culture, we strive for equal employment opportunities. To that effect, our Talent Acquisition team actively conducts multiple recruitment drives to find the right candidates. For us, all applicants are equal, and to remove gender bias during hiring, we give gender-neutral descriptions, ensure that interview panels are balanced, and hold gender sensitization sessions for recruiters and hiring managers. Even ‘Campus Recruits’ are welcomed and given every opportunity to shine through various innovative soft skills and technical training programs. Cybage is noted for churning campus recruits into rock-solid professionals in the shortest possible time.
                        </p>
                    </motion.div>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    className="flex flex-col lg:flex-row gap-8 lg:gap-[80px] justify-between items-center w-full"
                >
                    <div className="lg:max-w-[517px] w-full flex justify-center lg:justify-start overflow-hidden bg-slate-900 shrink-0 group relative aspect-[4/3] sm:aspect-[16/10] lg:aspect-[4/3]">
                        <motion.img
                            whileHover={{ scale: 1.04 }}
                            transition={{ duration: 0.6, ease: "easeOut" }}
                            src="/assets/diversity/img9.png"
                            alt="Fast zoom burst effect with neon blue light streaks on a dark background"
                            className="w-full h-full object-cover absolute inset-0 transition-transform duration-500"
                        />
                    </div>

                    <motion.div variants={fadeUpVariants} className="lg:max-w-[666px] w-full flex flex-col justify-between h-auto min-h-full">
                        <h2 className="text-[20px] md:text-[30px] font-[600] max-w-[561px] text-[#01386A] font-sora leading-[1.5] tracking-tight break-words w-full mb-6 lg:mb-[30px]">
                            We upskill our employees through learning & development programs
                        </h2>

                        <div className="w-full flex flex-col gap-4 sm:gap-5 mt-auto">
                            <p className="text-[14px] md:text-[16px] text-[#49577A] font-graphik font-[500] leading-relaxed break-words w-full">
                                At Cybage, we believe that the best way to help employees thrive and bridge their learning gap is through a blend of on-the-job experience and formal and informal learning. The objective is always to achieve quality work and consistent productivity, by focusing on the employees' happiness and contentment. We deliver this through a mixture of coaching, mentoring, training programs, workshops, and sessions with the managers and leadership.
                            </p>
                            <p className="text-[14px] md:text-[16px] text-[#49577A] font-graphik font-[500] leading-relaxed break-words w-full">
                                Our Technical Skills, Soft Skills, Knowledge Management, Work-Life Balance, Leadership, and Diversity programs provide opportunities for Cybagians at all levels to grow as employees. We ensure that every Cybagian has the privilege to upskill, and upgrade without bias!
                            </p>
                        </div>
                    </motion.div>
                </motion.div>

            </div>
        </section>
    );
};

export default HiringUpskilling;